import React from "react"
import { SelectField, MenuItem } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
interface IProps {
    readonly?: boolean
    width?: number | string
    state: string
    handleState(state): void
}
interface IState {
    state: string
}

const statesArray = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
    "CAN",
    "MEX"
]

export default class StateSelector extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            state: props.state
        }
        autobind(this)
    }

    render() {
        return (
            <SelectField
                disabled={this.props.readonly}
                floatingLabelText={strings.State}
                value={this.state.state}
                onChange={(event, key, state) => {
                    this.setState({ state }, () => this.props.handleState(state))
                }}
                style={{ width: this.props.width ? this.props.width : 300 }}
            >
                {statesArray.map((item, index) =>
                    <MenuItem key={index} value={item} primaryText={item} />
                )}
            </SelectField>
        )
    }
}